import * as React from 'react';
import { Helmet } from 'react-helmet';
import Carousel from 'react-elastic-carousel';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import GroupIcon from '@mui/icons-material/Group';
import AddIcon from '@mui/icons-material/Add';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import TimelineIcon from '@mui/icons-material/Timeline';
import { useParams, useNavigate } from 'react-router-dom';
import { useStoreActions } from 'easy-peasy';
import { FacebookShareButton, WhatsappShareButton, TwitterShareButton, EmailShareButton, LinkedinShareButton } from 'react-share';
import DonationPic from '../images/DonationPic.jpg';
import { Get } from '../services/http';
import DonateOptionSelectDialog from '../dialogs/donate-option-select';
import AddPartnerDialog from '../dialogs/add-partner-dialog';
import PartnersListDialog from '../dialogs/partners';
import PayCheckPopup from '../dialogs/pay-check-popup';
import DonationPopUp from '../dialogs/donation-popup';
import UtmLink from '../dialogs/utm-link';


let bannersList = [];
let numActiveSlide = 0;
let interval;
let intervalDonations;
let donationsList = [];
let scrollLoopId;
export default function RegularCampaign() {
    const [campaign, setCampaigns] = React.useState(null);
    const [optionsAmount, setOptionsAmount] = React.useState([]);
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const [banners, setBanners] = React.useState(null);
    const [activeSlide, setActiveSlide] = React.useState(0);
    const [donateSum, setDonateSum] = React.useState(null);
    const [isDonateSumDialog, setDonateSumDialog] = React.useState(false);
    const [currency, setCurrency] = React.useState(null);
    const [currencyOpen, setCurrencyOpen] = React.useState(false);
    const [campaignSlug, setCampaignSlug] = React.useState(false);
    const [isStopBlock, setStopBlock] = React.useState(false);
    const [minimumDonation, setMinimumDonation] = React.useState(0);
    const [campaignFirstDetails, setCampaignFirstDetails] = React.useState(false);
    const showSpinner = useStoreActions((action) => action.showSpinner);
    const hideSpinner = useStoreActions((action) => action.hideSpinner);
    const [isStartSlider, setStartSlider] = React.useState(false);
    const currencyList = ['$', '€', 'C$', 'A$', '£'];
    const defaultDonateSum = 0;
    const navigate = useNavigate();
    const { campaignID } = useParams();
    const { partnerSlug } = useParams();
    const [donatedList, setDonatedList] = React.useState(null);
    const [isStartDonationsSlider, setStartDonationsSlider] = React.useState(false);

    const numberWithCommas = (number) => {
        const intValue = parseInt(number);
        return intValue?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const openUrl = (newUrl) => {
        window.history.pushState({ html: '', pageTitle: '' }, '', newUrl);
        window.location.reload();
    };

    const getCampaignData = async () => {
        const projectData = await Get('/api/donation/GetProjectBySlug', { campaignID: campaignID, isFront: true });
        hideSpinner();
        if (!projectData.result) {
            openInfoPopup({ notice: projectData.message, isCallBack: true, callback: () => openUrl('/contact-us'), btnName: 'Contact Us!' });
        } else {
            setCampaigns(projectData.campaign);
            projectData.campaign?.donatedList?.donationList?.map((item) => {
                if (item.currency === '$') {
                    const showDonation = '$' + numberWithCommas(item.sum);
                    item.showDonationSum = showDonation;
                    return item;
                } else {
                    const showDonation = '$' + numberWithCommas(item.sum) + ' (' + item.currency + numberWithCommas(item.sumCurrency) + ')';
                    item.showDonationSum = showDonation;
                    return item;
                }
            });
            let object = [];
            if (projectData?.campaign?.optionsAmountMoney !== null) {
                object = JSON.parse(projectData.campaign.optionsAmountMoney);
            }
            // console.log('setDonatedList', projectData.campaign?.donatedList?.donationList);
            setDonatedList(projectData.campaign?.donatedList?.donationList);
            // donationsList = projectData.campaign?.donatedList?.donationList;
            // console.log('here is our object', object);
            setCampaignSlug(projectData.campaign.slug);
            const bannersObject = JSON.parse(projectData.campaign.banners);
            bannersObject?.map((item, index) => {
                if (index === 0) {
                    item.animationClassName = 'active_left';
                } else {
                    item.animationClassName = '';
                }
                return item;
            });
            setBanners(bannersObject);
            bannersList = bannersObject;
            if (object != null) {
                setOptionsAmount(object);
            }
            setCurrency(projectData.campaign.currency);
            // console.log('bannersObject', bannersObject);
        }
    };

    const slideNext = () => {
        // console.log('numActiveSlide', numActiveSlide);
        const sliderCount = bannersList?.length;
        const oldSlide = numActiveSlide;
        let nextSlide = numActiveSlide + 1;
        if (nextSlide >= sliderCount) {
            nextSlide = 0;
        }
        const slidedBanners = bannersList?.map((item, index) => {
            if (nextSlide === index) {
                item.animationClassName = 'active_left';
            } else if (oldSlide === index) {
                item.animationClassName = 'previous_left';
            } else {
                item.animationClassName = '';
            }
            return item;
        });
        setBanners(slidedBanners);
        setActiveSlide(nextSlide);
        numActiveSlide = nextSlide;
    };

    const openNext = () => {
        // const lastEl = donatedList[(donatedList.length - 1)];
        let splicedElements = [];
        let elements = document.getElementsByClassName('sc-list__item');
        if (elements === null) {
            return;
        }
        for (let i = 0; i < elements.length; i++) {
            splicedElements[i] = elements[i].outerHTML;
        }
        const firstEl = splicedElements[0];
        splicedElements[0] = '';
        splicedElements[splicedElements.length] = firstEl;
        let html = '';
        for (let i = 0; i < splicedElements.length; i++) {
            html += splicedElements[i].replace(' active', '');
        }
        // newCampaigns?.map((item) => { item.class = 'slider-multimple__item slide-left'; return item; });
        document.getElementById('donation-list').innerHTML = html;
        setTimeout(() => {
            let htmlAddActive = '';
            let elementsAddClass = document.getElementsByClassName('sc-list__item');
            for (let i = 0; i < elementsAddClass.length; i++) {
                console.log('elementsAddClass[i]', elementsAddClass[i]);
                elementsAddClass[i].className += ' active';
                htmlAddActive += elementsAddClass[i]?.outerHTML;
            }
            document.getElementById('donation-list').innerHTML = htmlAddActive;
        }, 10);
    };

    const doDonate = () => {
        const newDonateSum = document.getElementById('input-donate-sum').value;
        // console.log('donateSum', donateSum);
        if (donateSum >= 0) {
            openUrl('/donation-summary/' + campaignSlug + '/' + newDonateSum + '/' + currency);
        } else {
            openUrl('/donation-summary/' + campaignSlug + '/' + defaultDonateSum + '/' + currency);
        }
    };

    const handleDonationSumChange = () => {
        const newSum = document.getElementById('input-donate-sum').value;
        setDonateSum(newSum);
    };

    const changeDonateSum = (newSum) => {
        setDonateSum(newSum);
        document.getElementById('input-donate-sum').value = newSum;
        const urlPath = '/donation-summary/' + campaignSlug + '/' + newSum + '/' + currency;
        openUrl(urlPath);
    };

    const slidePrev = () => {
        const sliderCount = bannersList?.length;
        const oldSlide = numActiveSlide;
        let nextSlide = numActiveSlide - 1;
        if (nextSlide < 0) {
            nextSlide = (sliderCount - 1);
        }
        const slidedBanners = bannersList?.map((item, index) => {
            if (nextSlide === index) {
                item.animationClassName = 'active_right';
            } else if (oldSlide === index) {
                item.animationClassName = 'previous_right';
            } else {
                item.animationClassName = '';
            }
            return item;
        });
        setBanners(slidedBanners);
        setActiveSlide(nextSlide);
        numActiveSlide = nextSlide;
    };
    const toggleCurrency = () => {
        const isOpen = !currencyOpen;
        setCurrencyOpen(isOpen);
    };
    const setCurrencyValue = (newCurrency) => {
        setCurrency(newCurrency);
        setCurrencyOpen(false);
    };
    const setCookie = (name, value, days) => {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    };
    const setPartner = (newPartnerSlug) => {
        setCookie('newPartnerSlug', newPartnerSlug, 386);
    };

    const getCampaignFirstDetails = async () => {
        const projectData = await Get('/api/donation/GetCampaignFirstDetails', { campaignID: campaignID });

        setCampaignFirstDetails(projectData);
    };

    const startSlider = () => {
        setStartSlider(true);
        // console.log('startSlider');
        interval = setInterval(() => {
            slideNext();
            // console.log('slideNext');
        }, 5000);
    };

    const stopSlider = () => {
        // console.log('stopSlider');
        setStopBlock(true);
        clearInterval(interval);
    };

    const incrementScroll = () => {
        let count = 0;
        let finishCount = 58;
        const speedPerCount = 10; // sec 1000 

        const animationInterval = setInterval(() => {
            document.getElementById('side-scrollbar').scrollBy(0, 1);
            count++;
            if (finishCount < count) clearInterval(animationInterval);
        }, speedPerCount);
    };

    const startDonationsSlider = () => {
        setStartDonationsSlider(true);
        // console.log('start Donations Slider');
        intervalDonations = setInterval(() => {
            openNext();
            // console.log('openNext');
        }, 2000);
    };

    let items = [{ title: 'Donation Card' }, { title: 'Donation Card' }, { title: 'Donation Card' }, { title: 'Donation Card' }];
    let breakPoints = [{ width: 500, itemsToShow: 1 }, { width: 768, itemsToShow: 4 }, { width: 1200, itemsToShow: 4 }, { width: 1500, itemsToShow: 4 }];

    React.useEffect(() => {
        getCampaignFirstDetails();
        showSpinner();
        // console.log('window.location.href', window.location.href);
        document.getElementById('input-donate-sum').value = defaultDonateSum;
        getCampaignData();

        if (isStartSlider === false) {
            startSlider();
        }

        if (donatedList !== null) {
            if (isStartDonationsSlider === false) {
                startDonationsSlider();
            }
        }

        if (partnerSlug !== null) {
            // console.log('partnerSlug', partnerSlug);
            setPartner(partnerSlug);
        }
    }, [campaignSlug]);

    return (
        <>
            <Helmet>
                <title>World of Tzedaka - Campaign</title>
            </Helmet>
            <main className="main">
                <DonateOptionSelectDialog isOpen={isDonateSumDialog} setOpen={setDonateSumDialog} optionsAmount={optionsAmount} campaign={campaign} />
                <div className="banner" style={{ 'background-image': 'url(' + campaignFirstDetails?.mainImage + ')' }}></div>
                <section className="promo bg-color">
                    <div className="container">
                        <div className="bg-color" style={{ marginTop: '-100px', paddingTop: '10px', paddingBottom: '10px', paddingRight: '30px', paddingLeft: '30px' }}>
                            <p style={{ marginBottom: '10px', textAlign: 'start', color: 'black' }} className="font-small bold">Main {'>>'} <span style={{ color: '#088fdd' }}>{campaignFirstDetails?.name?.length >= 30 ? campaignFirstDetails?.name?.substring(0, 20) + '...' : campaignFirstDetails?.name}</span></p>
                            <h3 style={{ textTransform: 'uppercase', textAlign: 'start', color: 'black' }}>{campaignFirstDetails?.name}</h3>
                            <hr />
                        </div>
                        <div className="promo__wrap">
                            <div className="promo__slider ">
                                <div className="slider">
                                    <div className="slider__wrapper">
                                        {isStopBlock === false ? (<div className="slider_stop_block" onClick={stopSlider}></div>) : ''}
                                        {bannersList?.map((bannersItem, index) => (
                                            bannersItem?.type === 'image' ? (
                                                <div className={'slider__item ' + bannersItem.animationClassName}>
                                                    <div className="video" style={{ 'background-image': 'url(' + bannersItem?.url + ')' }}>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className={'slider__item ' + bannersItem.animationClassName}>
                                                    <div className="video">
                                                        <iframe width="100%" height="auto" src={bannersItem?.code} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                                    </div>
                                                </div>
                                            )
                                        ))}
                                    </div>
                                    <div className="slider__prev" onClick={slidePrev}>
                                        {/* <img src="/img/sprite/arrow-left.svg" alt="" /> */}
                                        <ArrowBackIosNewIcon style={{ color: 'white', fontSize: '40px' }} />
                                    </div>
                                    <div className="slider__next" onClick={slideNext}>
                                        {/* <img src="/img/sprite/arrow-left.svg" alt="" /> */}
                                        <ArrowForwardIosIcon style={{ color: 'white', fontSize: '40px' }} />

                                    </div>
                                    <div className="slider__dots">
                                        {bannersList?.map((bannersItem, index) => (<div className={activeSlide === index ? 'slider__bullet _active' : 'slider__bullet'}></div>))}
                                    </div>
                                </div>
                            </div>
                            <div className="promo__side side-promo">
                                {campaign != null ? (
                                    <div className="side-promo__title">
                                        Raised Percent: <span className="side-promo__price">
                                            ${campaign?.donatedSumInfo.sum !== undefined
                                                ? numberWithCommas(campaign?.donatedSumInfo.sum)
                                                : 0}
                                        </span>

                                    </div>
                                ) : ''}
                                <div className="side-promo__progress progress">

                                    <div className="progress__track" style={{ width: (parseInt(campaign?.donatedSumInfo.percent) >= 0 ? campaign?.donatedSumInfo.percent : '0') + '%' }}></div>
                                </div>
                                {campaign != null ? (
                                    <div className="side-promo__icons-grid icons-grid">
                                        <div className="icons-grid__item">
                                            <div className="icons-grid__icon">
                                                {/* <img src="/img/gif/graph.gif" alt="" /> */}
                                                {/* <TimelineIcon style={{ fontSize: '40px', color: 'red' }} /> */}
                                                <img src="/img/sprite/lchart.png" alt="" />
                                            </div>
                                            <div className="icons-grid__title">Fund Raised: <span>{campaign?.donatedSumInfo.percent !== undefined
                                                ? parseFloat(campaign?.donatedSumInfo.percent).toFixed(2) + '%'
                                                : 0 + '%'}</span></div>
                                        </div>
                                        <div className="icons-grid__item" style={{ borderLeft: '1px solid black', borderRight: '1px solid black' }}>
                                            <div className="icons-grid__icon">
                                                {/* <img src="/img/gif/heart.gif" alt="" /> */}
                                                {/* <TrackChangesIcon style={{ fontSize: '40px', color: 'red' }} /> */}
                                                <img src="/img/sprite/arw.png" alt="" />
                                            </div>
                                            <div className="icons-grid__title">Funding Goal: <span>${parseInt(campaign?.donatedGoal) >= 0
                                                ? numberWithCommas(campaign?.donatedGoal)
                                                : 0}</span></div>
                                        </div>
                                        <div className="icons-grid__item">
                                            <div className="icons-grid__icon">
                                                {/* <img src="/img/gif/people.gif" alt="" /> */}
                                                {/* <GroupIcon style={{ fontSize: '40px', color: 'red' }} /> */}
                                                <img src="/img/sprite/usr.png" alt="" />
                                            </div>
                                            <div className="icons-grid__title">Donors: <span>{campaign?.donatedSumInfo.count > 0
                                                ? numberWithCommas(campaign?.donatedSumInfo.count)
                                                : 0}</span></div>
                                        </div>
                                    </div>
                                ) : ''}

                                <div className="side-promo__social social">
                                    <WhatsappShareButton url={window.location.href} title={campaign?.name + ': '}>
                                        <a href="#" class="social__link social__link--whatsapp">
                                            <img src="/img/sprite/whatsapp.svg" alt="" />
                                        </a>
                                    </WhatsappShareButton>
                                    <TwitterShareButton url={window.location.href} title={campaign?.name + ': '}>
                                        <a href="#" class="social__link social__link--twitter">
                                            <img src="/img/sprite/twitter.svg" alt="" />
                                        </a>
                                    </TwitterShareButton>
                                    <FacebookShareButton url={window.location.href} quote={campaign?.name}>
                                        <a href="#" class="social__link social__link--facebook">
                                            <img src="/img/sprite/facebook.svg" alt="" />
                                        </a>
                                    </FacebookShareButton>
                                    <EmailShareButton url={window.location.href} subject={campaign?.name}>
                                        <a href="#" class="social__link social__link--mail">
                                            <img src="/img/sprite/mail.svg" alt="" />
                                        </a>
                                    </EmailShareButton>
                                    <UtmLink />
                                </div>
                                {/* <AddPartnerDialog campaignId={campaignID} campaignSlug={campaignSlug} /> */}
                            </div>
                        </div>
                        <div className="box">
                            <div className="" >
                                <div className="box__title" style={{ color:'#1D1E1D'}}>Presert Donation:</div>
                            </div>
                            <div className="" style={{marginTop:'20px'}}>
                                <div className="donations">
                                    <div className="none">
                                        {optionsAmount?.map((optionsAmountItem, index) => (
                                            <div className="donations__item donations-card" onClick={() => changeDonateSum(optionsAmountItem.sum)}>
                                                <div className="donations-card__img" style={{ 'background-image': 'url(' + optionsAmountItem?.image + ')' }}></div>
                                                <div className="donations-card__content">
                                                    <div className="donations-card__title">{optionsAmountItem.title}</div>
                                                    <div className="donations-card__text">{optionsAmountItem.text}</div>
                                                    <div className="donations-card__donate"> Donate: <br /> {currency}{numberWithCommas(optionsAmountItem.sum)}</div>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="donations__input">
                                            <div className="donate-form">
                                                <div className="donate-form__buttons">
                                                    <div className="donate-form__plus"></div>
                                                    <div className="donate-form__minus"></div>
                                                </div>
                                                <div className={currencyOpen ? 'donate-form__sel form-sel _open' : 'donate-form__sel form-sel'}>
                                                    <div className="form-sel__button" onClick={toggleCurrency}>{currency}</div>
                                                    <div className="form-sel__drop _open">
                                                        {currencyList?.map((item) => (
                                                            <div className="form-sel__drop-item" onClick={() => setCurrencyValue(item)}>{item}</div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <input type="number" className="donate-form__input" onChange={handleDonationSumChange} id="input-donate-sum" />
                                            </div>
                                        </div>
                                        {campaign != null ? (
                                            <div className="text-center">
                                                <a 
                                                style={{ 

                                                cursor: 'pointer', 
                                                textDecoration: 'none', 
                                                fontWeight: '700', 
                                                paddingLeft: '120px', 
                                                paddingRight: '120px', 
                                                paddingTop: '20px', paddingBottom: '20px' 
                                                }} 
                                                className="login_button" onClick={doDonate}> 
                                                <span> <VolunteerActivismIcon style={{ fontSize: '22px' }} /> </span> DONATE!</a>
                                            </div>
                                        ) : ''}
                                        <div className="text-center" style={{ marginTop: '20px' }}>
                                            <PayCheckPopup campaignName={campaign?.name} campaignID={campaign?.id} />
                                            <div className="donations__info">
                                                <div className="donations__info-inner">
                                                    <span>Donation Hotline:</span> Call Now {campaign?.phoneNum} <br />
                                                    <span>Campaign #:</span>{campaign?.id}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Carousel breakPoints={breakPoints}>
                                        {
                                            optionsAmount?.map((optionsAmountItem, index) => (
                                                <>
                                                    <Card onClick={() => changeDonateSum(optionsAmountItem.sum)} className="card-back" sx={{ maxWidth: '200px' }} style={{ background:'none' , boxShadow:'none', position: 'relative' }}>
                                                        <CardMedia
                                                            component="img"
                                                            height="140"
                                                            image={optionsAmountItem?.image}
                                                            alt="green iguana"
                                                        />
                                                        <CardContent style={{ backgroundColor: '#088fdd' }}>
                                                            <Typography gutterBottom variant="h5" className="slider-heading" component="div" style={{ color: 'white' }}>
                                                                {optionsAmountItem.title}
                                                            </Typography>
                                                            <p className="mb-0 font-small don-slider-text">{optionsAmountItem?.text}</p>
                                                        </CardContent>
                                                        <div className='slider-button' style={{ textAlign: 'center' }}>
                                                            <button type="submit" className="bg-red login_button" style={{ paddingTop: '10px', paddingBottom: '10px', paddingRight: '5px', paddingLeft: '5px', width: '50%', fontWeight: 'bold' }}> Donate: {currency}{numberWithCommas(optionsAmountItem.sum)}</button>
                                                        </div>
                                                    </Card>
                                                </>

                                            ))
                                        }
                                    </Carousel>
                                </div>
                            </div>
                        </div>
                        {campaign != null ? (
                                <div className="text-center" style={{ marginTop: '40px', marginBottom: '80px' }}>
                                    <a class onClick={doDonate} 
                                    style={{ cursor: 'pointer',
                                    fontSize:'22px',
                                    fontFamily:'Rubik',

                                     textDecoration: 'none', fontWeight: '700', paddingLeft: '120px', paddingRight: '120px', paddingTop: '15px', paddingBottom: '15px' }} 
                                    className="login_button"> <span> 
                                    <img src="/img/sprite/hearthand.png" width="35px" />  
                                    {/* <img src="/img/sprite/usr.png" alt="" width="15px" /> */}
                                    </span>  DONATE</a>
                                    <div style={{ marginTop: '30px' }}>
                                        <PayCheckPopup campaignName={campaign?.name} />
                                    </div>
                                </div>
                            ) : ''}
                        <div className="context">
                            <div className="context__wrap article-content">
                                <div className="context__side ">
                                    {campaign?.isHatzedakaCertificate === true ? (
                                        <div class="rabanim-wrapper">
                                            <div class="rabanim-text">
                                                THIS CAUSE HAS BEEN VERIFIED<br />
                                                BY THE VA’AD HATZEDAKAH - <br />
                                                TOMCHEI TZEDEKAH OF LAKEWOOD
                                            </div>
                                            <div class="rabanim-account">Certification/Account <span># {campaign?.hatzedakaCertificateNumber} </span></div>
                                        </div>
                                    ) : ''}
                                    <div className="side-context">
                                        <div className="side-context__top">
                                            <div className="side-context__title">
                                                RECENT DONATIONS
                                                <div>{campaign?.donatedSumInfo.count > 0 ? numberWithCommas(campaign?.donatedSumInfo.count) : 0} DONORS</div>
                                            </div>
                                        </div>
                                        <div id="side-scrollbar" className="side-context__body scrollbar">
                                            {donatedList !== 0 ? (
                                                <ul className="sc-list" id="donation-list">
                                                    {donatedList?.map((donationItem, index) => (
                                                        <li className="sc-list__item">
                                                            <div className="sc-list__content">
                                                                <div className="sc-list__title">{donationItem.pseudoName}</div>
                                                                {/* <div className="sc-list__subtitle">{donationItem.ambassadorName != null ? 'via ' + donationItem.ambassadorName : ''}</div> */}
                                                                <div className="sc-list__text">{donationItem.dedication}</div>
                                                            </div>

                                                            <div className="sc-list__price">{donationItem.showDonationSum}</div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <ul className="sc-list">
                                                    No Donations Yet
                                                </ul>
                                            )}

                                        </div>
                                        <DonationPopUp />
                                    </div>
                                    {/*  <PartnersListDialog campaignId={campaign?.id} /> */}
                                </div>
                                <div className="context__content" dangerouslySetInnerHTML={{ __html: campaign?.text }} />
                                {
                                        console.log("regular: ", campaign?.text)
                                    }
                            </div>
                            {campaign != null ? (
                                <div className="text-center" style={{ marginTop: '40px', marginBottom: '80px' }}>
                                    <a class onClick={doDonate} 
                                    style={{ cursor: 'pointer',
                                    fontSize:'22px',
                                    fontFamily:'Rubik',

                                     textDecoration: 'none', fontWeight: '700', paddingLeft: '120px', paddingRight: '120px', paddingTop: '15px', paddingBottom: '15px' }} 
                                    className="login_button"> <span> 
                                    <img src="/img/sprite/hearthand.png" width="35px" />  
                                    {/* <img src="/img/sprite/usr.png" alt="" width="15px" /> */}
                                    </span>  DONATE</a>
                                    <div style={{ marginTop: '30px' }}>
                                        <PayCheckPopup campaignName={campaign?.name} />
                                    </div>
                                </div>
                            ) : ''}
                        </div>
                        {/* <DonationCardCarousel /> */}

                    </div>
                </section>
            </main>
            {campaign != null ? (
                <div class="donate-fixed">
                    <div class="container">
                        <div class="donate-fixed__inner">
                            <a href="#" class="donate-fixed__button" onClick={doDonate}>
                                Donate Now!
                                <img src="/img/sprite/wallet.svg" alt="" />
                            </a>
                            <div class="donate-fixed__social social">
                                <WhatsappShareButton url={window.location.href} title={campaign?.name + ': '}>
                                    <a href="#" class="social__link social__link--whatsapp">
                                        <img src="/img/sprite/whatsapp.svg" alt="" />
                                    </a>
                                </WhatsappShareButton>
                                <TwitterShareButton url={window.location.href} title={campaign?.name + ': '}>
                                    <a href="#" class="social__link social__link--twitter">
                                        <img src="/img/sprite/twitter.svg" alt="" />
                                    </a>
                                </TwitterShareButton>
                                <FacebookShareButton url={window.location.href} quote={campaign?.name}>
                                    <a href="#" class="social__link social__link--facebook">
                                        <img src="/img/sprite/facebook.svg" alt="" />
                                    </a>
                                </FacebookShareButton>
                                <EmailShareButton url={window.location.href} subject={campaign?.name}>
                                    <a href="#" class="social__link social__link--mail">
                                        <img src="/img/sprite/mail.svg" alt="" />
                                    </a>
                                </EmailShareButton>
                            </div>
                        </div>
                    </div>
                </div>
            ) : ''}
        </>
    );
}
